import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const Trash2 = ({ color, size, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '22px'}
      height={size || '22px'}
      color={color || 'currentColor'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path d="M8.5899 3H15.4101V2H8.5899V3Z" fill="#757575" />
      <path d="M20 5H4V4H20V5Z" fill="#757575" />
      <path d="M7 21.0001V6.00488H6V22.0001H18V6.00488H17V21.0001H7Z" fill="#757575" />
      <path d="M14 19.0235V8H15V19.0235H14Z" fill="#757575" />
      <path d="M8.99969 8V19.0235H9.99969V8H8.99969Z" fill="#757575" />
    </StyledSvg>
  );
};
